module.exports = __webpack_public_path__ + "static/media/myorders.51b62653.svg";